import { create } from 'zustand';

export const MIN_ZOOM = 0.25;
export const MAX_ZOOM = 2;

interface TableMapZoomState {
  zoomByMapId: Record<string, number>;
  // Signal counter — bumped every time a consumer asks to fit the view to content.
  // TableMap.tsx watches this and runs the fit logic imperatively (it has the refs).
  fitViewRequestId: number;
  setZoom: (mapId: string, zoom: number) => void;
  requestFitView: () => void;
}

export const useTableMapZoomStore = create<TableMapZoomState>((set) => ({
  zoomByMapId: {},
  fitViewRequestId: 0,
  setZoom: (mapId, zoom) => set((state) => ({ zoomByMapId: { ...state.zoomByMapId, [mapId]: zoom } })),
  requestFitView: () => set((state) => ({ fitViewRequestId: state.fitViewRequestId + 1 })),
}));
